import { useStore } from 'effector-react'
import {
  rentalContractModel,
  useRentalContractStatus,
} from '~/entities/RentalContract'
import { Button } from '~/shared/ui/Buttons'
import { Wrapper, Title, Description } from './styled'

export function RentalContractSigningAlert() {
  const rentalContract = useStore(rentalContractModel.$rentalContract)

  const { isSigning } = useRentalContractStatus()

  if (!rentalContract || !isSigning) return null

  return (
    <Wrapper data-testid='rental-contract-signing-alert'>
      <Title>Новый договор</Title>
      <Description>Поступил договор на подписание</Description>

      <Button
        variant='textLink'
        to='/rental-contract-signing'
        contentProps={{ style: { padding: '0' } }}
      >
        Открыть
      </Button>
    </Wrapper>
  )
}
